import HeroModule from './HeroModule.component';

export default HeroModule;